<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="current_page"
    :page-sizes="[10, 20, 30, 40]"
    :page-size="10"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total">
    </el-pagination>
</template>

<script>
export default {
    props:{
        total: {
            type: Number,
            required: true
        },
        current_page:{
            type: Number,
            required: true
        }
    },
    data(){
        return {

        }
    },
    methods:{
       handleSizeChange(val){
           this.$emit('sizeChange', val)
       },
       handleCurrentChange(val){
           this.$emit('currentChange', val)
       }
    }
}
</script>

<style lang='scss' scoped>
    /deep/.el-input--mini .el-input__inner{
        width: 100px !important;
    }
</style>